import { render, staticRenderFns } from "./statisticDialog1.vue?vue&type=template&id=302c3810&scoped=true&"
import script from "./statisticDialog1.vue?vue&type=script&lang=js&"
export * from "./statisticDialog1.vue?vue&type=script&lang=js&"
import style0 from "./statisticDialog1.vue?vue&type=style&index=0&id=302c3810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302c3810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302c3810')) {
      api.createRecord('302c3810', component.options)
    } else {
      api.reload('302c3810', component.options)
    }
    module.hot.accept("./statisticDialog1.vue?vue&type=template&id=302c3810&scoped=true&", function () {
      api.rerender('302c3810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupChat/components/statisticDialog1.vue"
export default component.exports